import Campaigns from './Campaigns';

export default Campaigns;
